
export default function ContactHeroSection() {
  return (
    <section className="py-12 sm:py-20 bg-dark-900 relative overflow-hidden">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-red-700/20 via-dark-900 to-dark-800"></div>
      
      <div className="container mx-auto px-4 sm:px-6 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="text-red-500 font-semibold text-base sm:text-lg mb-3 sm:mb-4">Get in Touch</div>
          <h1 className="text-3xl sm:text-4xl lg:text-6xl font-bold text-white mb-4 sm:mb-6 leading-tight">
            Ready to Discuss Your <span className="text-red-500">Mortgage Needs?</span>
          </h1>
          <p className="text-lg sm:text-xl text-gray-300 mb-6 sm:mb-8 leading-relaxed max-w-3xl mx-auto px-2 sm:px-0">
            Whether you're buying your first home, refinancing, or exploring private lending options, 
            I'm here to help you navigate your mortgage journey with confidence.
          </p>
          
          {/* Quick contact options */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 max-w-2xl mx-auto mb-8 sm:mb-12 px-2 sm:px-0">
            <a href="tel:5196583026" className="bg-dark-800 border border-dark-700 rounded-xl p-4 sm:p-6 hover:bg-dark-700 transition-colors duration-300 cursor-pointer group">
              <i className="ri-phone-line text-2xl sm:text-3xl text-red-500 mb-2 sm:mb-3 group-hover:scale-110 transition-transform duration-300"></i>
              <h3 className="font-bold text-base sm:text-lg text-white mb-1 sm:mb-2">Call Directly</h3>
              <p className="text-red-500 font-semibold text-sm sm:text-base">(519) 658-3026</p>
              <p className="text-gray-400 text-xs sm:text-sm mt-1 sm:mt-2">Available Mon-Fri 9AM-7PM</p>
            </a>
            
            <div className="bg-dark-800 border border-dark-700 rounded-xl p-4 sm:p-6">
              <i className="ri-mail-line text-2xl sm:text-3xl text-red-500 mb-2 sm:mb-3"></i>
              <h3 className="font-bold text-base sm:text-lg text-white mb-1 sm:mb-2">Send a Message</h3>
              <p className="text-gray-300 text-xs sm:text-sm">Use the form below for detailed inquiries</p>
              <p className="text-gray-400 text-xs sm:text-sm mt-1 sm:mt-2">Response within 4 hours</p>
            </div>
          </div>
          
          {/* Professional credentials */}
          <div className="flex justify-center items-center space-x-4 sm:space-x-8 text-gray-400 px-4">
            <div className="text-center">
              <div className="font-bold text-red-500 text-sm sm:text-lg">Licensed</div>
              <div className="text-xs">Lic# 13121</div>
            </div>
            <div className="text-center">
              <div className="font-bold text-red-500 text-sm sm:text-lg">Level 2</div>
              <div className="text-xs">Certified</div>
            </div>
            <div className="text-center">
              <div className="font-bold text-red-500 text-sm sm:text-lg">25+ Years</div>
              <div className="text-xs">Experience</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
